module.exports = __webpack_public_path__ + "img/2_ls.3ea29bd3.gif";